<template>
  <v-app id="searchGuestReminder">
    <v-main>
      <v-container fluid>
        <v-card flat>

          <v-row cols="12" no-gutter dense>
            <v-col cols="3" class="ml-4">
              <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail />
            </v-col>
            <v-col cols="3" class="pt-4 ml-8">
              <v-btn small plain v-on:click="expandAll()">expand all</v-btn>                          
              <v-btn small plain v-on:click="collapseAll()">collapse all</v-btn>
            </v-col>                        
          </v-row>  

          <v-data-table 
              :items="items" 
              :items-per-page="50" 
              :footer-props="{'items-per-page-options': [50, 100, 200, 300, 500]}"
              :headers="headers"
              :search="search"        
              :expanded.sync="expanded"
              show-expand
              item-key="huov_code">
            <template v-slot:expanded-item="{  headers, item }">               
              <td :colspan="headers.length" class="py-2">
                <table  style="width: 100%; border-collapse: collapse;" v-if="item.nott.length!==0">
                  <tr v-for="(note, idx) in item.nott" :key="note.nott_dt" :class="{'bg-gray': !isEven(idx)}">
                    <td style="width: 150px; padding-left: 20px; vertical-align: top;" class="py-2">{{ note.nott_dt }}</td>
                    <td style="width: 100px; vertical-align: top;" class="py-2">{{ note.nott_gebr_code }}</td>
                    <td class="py-2" style="vertical-align: top;"><span v-html="note.nott_tekst"></span></td>                    
                  </tr>
                </table>
                <table v-else style="width: 100%; border-collapse: collapse;"><em style="width: 150px; padding-left: 20px; vertical-align: top;" class="py-2">No data to display</em></table>
              </td>                      
            </template>

            <template v-slot:item.huov_code = "{item}">   
              <td @click="$router.open('/huov/onHuov/' + item.huov_encrid)"><a> {{item.huov_code}} </a></td>
            </template>

            <template v-slot:item.hust_code = "{item}">   
              <td><v-chip :color=item.hust_kleur class="hust-code">{{item.hust_code}}</v-chip></td>
            </template>

            <template v-slot:item.huis_code = "{item}">   
              <td @click="$router.open('/huis/onHuis/' + item.huis_encrid)"><a> {{item.huis_code}} </a></td>
            </template>            

            <template v-slot:item.huov_dt = "{item}">   
              <td>{{ $moment(item.huov_dt).format("DD-MMM-YYYY HH:mm") }}</td>   
            </template>           

            <template v-slot:item.huov_dagen_na_boeking = "{item}">   
              <td><v-chip :color=item.hust_kleur class="hust-code">{{item.huov_dagen_na_boeking}}</v-chip></td>
            </template>

            <template v-slot:item.huov_van_dat = "{item}">   
              <td>{{ $moment(item.huov_van_dat).format("DD-MMM-YYYY") }}</td>   
            </template>     

            <template v-slot:item.klnt_naam = "{item}">   
              <td @click="$router.open('/klnt/onKlnt/' + item.klnt_encrid)"><a> {{item.klnt_naam}} </a></td>
            </template>     

            <template v-slot:item.huov_tebetalen_dt = "{item}">     
              <td>{{$moment(item.huov_tebetalen_dt).format("DD-MM-YYYY HH:mm")}}</td>
            </template>

            <template v-slot:item.huov_opeisbaar = "{item}">     
              <td class="amount">{{item.huov_opeisbaar | nl_numberformat | prefix_euro }}</td>            
            </template> 

            <template v-slot:item.huov_reminders = "{item}">     
              <td><v-chip :color=item.huov_reminders_kleur>{{item.huov_reminders}}</v-chip></td>
            </template> 

            <template v-slot:item.hoka_groep_nr = "{item}">     
              <td>
                 <v-icon  @click="nott(item.huov_encrid, item.hoka_groep_nr);">mdi-clipboard-text-outline</v-icon>
                 <v-tooltip v-if="item.isRefundable" bottom>
                   <template v-slot:activator="{ on, attrs }">
                     <v-icon class="ml-2" style="color: dodgerblue;" v-on="on" v-bind="attrs">mdi-alpha-r-circle</v-icon>
                   </template>
                   <span>Refundable</span>
                 </v-tooltip>
                 <v-icon v-else class="ml-2" style="visibility: hidden;">mdi-alpha-r-circle-outline</v-icon>
              </td>            
            </template> 

          </v-data-table>       

        </v-card>
      </v-container>
    </v-main>

    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    <nott ref="nott"></nott>

  </v-app>
</template>

<script>

  import navBar from "@/components/ui/navbars/navbar.vue";
  import nott from "@/components/nott";
  import mxnumberformat from '@/mixins/amount_nl';

  import {bus} from "../../main";

  export default {
    components: {
      navBar,
      nott
    },
    data() {
      return {
        items: [],
        search: '',
        expanded: [],
        headers: [
          { text: 'Id', value: 'huov_code' },
          { text: 'Status', value: 'hust_code' },
          { text: 'Acco', value: 'huis_code' },
          { text: 'Booking', value: 'huov_dt' },
          { text: 'Days after bk', value: 'huov_dagen_na_boeking' },
          { text: 'Arrival', value: 'huov_van_dat' },
          { text: 'Guest', value: 'klnt_naam' },
          { text: 'Crt/Lang', value: 'klnt_landtaal' },
          { text: 'Telephone', value: 'klnt_tel1_vcs' },
          { text: 'Partner', value: 'inpt_naam' },
          { text: 'Date due', value: 'huov_tebetalen_dt' },
          { text: 'Amount due', value: 'huov_opeisbaar', align: "end", sortable: false},
          { text: 'Reminders - Read', value: 'huov_reminders'},
          { text: 'Remark', value: 'hoka_groep_nr', sortable: false},
          { text: '', value: 'data-table-expand', sortable: false },
        ]
      }
    },
    mixins:[mxnumberformat],  
    created(){
      bus.$on("addNote", (data) => {
        if(data!==0){
          this.getReminders();
        }
      });   
    },
    mounted() {
      this.getReminders();
    },
    methods: {
      getReminders(){
        this.$axios
        .post("ares/json/ares/huov/searchGuestReminder.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchGuestReminder"
          },
          searchGuestReminder: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            console.log(res.data.searchGuestReminder);
            this.items = res.data.searchGuestReminder;
            this.expandAll();
          }
        })
        .finally(() => {
          this.loading = false;
        });
      },
      nott(huov_encrid, hoka_groep_nr) {
        this.$refs.nott.open("huov", huov_encrid, "Guest payment reminder - Group " + hoka_groep_nr);
      },
      collapseAll() {
        this.expanded = [];
      }, 
      expandAll(){
        this.items.filter(e => e.nott.length !==0 ? this.expanded.push(e) : false);
      },          
      isEven (idx){
        return (idx%2 === 0)
      }
    }
  };

</script> 

<style scoped>
  .indent{
    text-align: center;
  }
  .encapsulated_td{
    border-top: 10px solid transparent;
  }
  .amount{
    text-align: end;
  }
  .hust-code{
    color:white;
  }
  .bg-gray {
    background-color: #e8e8e8 !important;
  }
</style>
